import { render, staticRenderFns } from "./HorizontalTitleList.vue?vue&type=template&id=b6ef5bb6"
import script from "./HorizontalTitleList.vue?vue&type=script&setup=true&lang=ts"
export * from "./HorizontalTitleList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HorizontalTitleList.vue?vue&type=style&index=0&id=b6ef5bb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports